import React from 'react';
import { createContext } from '@shared/utils/createContext';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';
import { useQueryParams } from '@shared/utils/hooks/useQueryParams';
import { useDisclosure } from '@withjoy/joykit';
import { AUTH_REDIRECT_PARAM } from '@apps/card/routes/PublicShop/components/login/Components/AccountForm/useAuthRedirectURLs';

type PublicShopLoginContext = {
  goToLogin: () => void;
  isLoginModalOpen: boolean;
  onCloseLoginModal: () => void;
};

const [Provider, usePublicShopLoginContext] = createContext<PublicShopLoginContext>({ name: 'PublicShopLoginContext' });

const PublicShopLoginProvider = ({ children }: { children: React.ReactNode }) => {
  const query = useQueryParams();

  const { isOpen: isLoginModalOpen, onClose: onCloseLoginModal, onOpen: onOpenLoginModal } = useDisclosure({ defaultIsOpen: query?.[AUTH_REDIRECT_PARAM] === 'true' });

  const goToLogin = useEventCallback(() => {
    onOpenLoginModal();
  });

  return <Provider value={{ isLoginModalOpen, onCloseLoginModal, goToLogin }}>{children}</Provider>;
};

export { PublicShopLoginProvider, usePublicShopLoginContext };
